import { Box, Button, Center, HStack, Icon, Text } from '@chakra-ui/react'
import { useTranslation } from '@infraloop/i18n'
import { LuArrowRight, LuZap } from 'react-icons/lu'
import { Link as RouterLink } from 'react-router'

import { buildPlanUrl } from '../utils'

/**
 * Upgrade prompt shown in place of the create-project button when the user's plan does
 * not allow creating projects. The CTA navigates to the plan section of the user page.
 */
const SubscriptionUpgradeCard = () => {
  // Hooks
  const { t } = useTranslation()

  return (
    <HStack
      position="relative"
      overflow="hidden"
      mt="16px"
      px="26px"
      py="24px"
      gap="22px"
      flexWrap="wrap"
      borderRadius="16px"
      background="linear-gradient(135deg, #0E3B62 0%, #11538B 55%, #186FB9 100%)"
      data-testid="subscription-upgrade-card"
    >
      <Box
        position="absolute"
        inset={0}
        backgroundImage="radial-gradient(rgba(143,217,230,.35) 1.1px, transparent 1.1px)"
        backgroundSize="15px 15px"
        opacity={0.5}
        pointerEvents="none"
      />
      <Center
        position="relative"
        w="48px"
        h="48px"
        borderRadius="12px"
        bg="whiteAlpha.200"
        color="white"
        flexShrink={0}
      >
        <Icon as={LuZap} boxSize="23px" />
      </Center>
      <Box position="relative" flex="1" minW="240px">
        <Text fontSize="16px" fontWeight="bold" color="white" letterSpacing="-0.01em">
          {t('hatsuly.subscription.upgradeTitle')}
        </Text>
        <Text fontSize="13px" color="whiteAlpha.800" mt="4px" lineHeight="1.6">
          {t('hatsuly.subscription.upgradeBody')}
        </Text>
      </Box>
      <Button
        asChild
        position="relative"
        gap="8px"
        px="20px"
        py="11px"
        h="auto"
        bg="white"
        color="primary.700"
        borderRadius="9px"
        fontSize="14px"
        fontWeight="bold"
        flexShrink={0}
        _hover={{ bg: 'gray.100' }}
        data-testid="view-plans"
      >
        <RouterLink to={buildPlanUrl()}>
          {t('hatsuly.subscription.viewPlans')}
          <Icon as={LuArrowRight} boxSize="16px" />
        </RouterLink>
      </Button>
    </HStack>
  )
}

export default SubscriptionUpgradeCard
